import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gutter-y-s3 flex-grow-1" }
const _hoisted_2 = { class: "w-12 sm:w-4" }
const _hoisted_3 = { class: "w-12 sm:w-4" }
const _hoisted_4 = { class: "w-12 sm:w-4" }
const _hoisted_5 = {
  key: 0,
  class: "flex align-items-center gutter-x-s1 flex-nowrap"
}
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = {
  key: 1,
  class: "flex align-items-center"
}

import BigNumber from 'bignumber.js';
import { useI18n } from 'vue-i18n';
import { format, printUSD } from '@/utils/format';
import Caption from '@/components/Caption.vue';
import { SingleSideToken } from '../models/single-side-token';
import { SingleSideActionName } from '../models/single-side';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenData',
  props: {
    token: null,
    action: null
  },
  setup(__props: any) {

const props = __props as {
  token: SingleSideToken;
  action: SingleSideActionName;
}

const { t } = useI18n();



const printAPR = () => {
  const apr = props.token.apr.toNumber();
  if (apr < 1) {
    return `< 1%`;
  }
  return apr > 10000 ? `> 10 000%` : `${format(apr.toFixed(2))}%`;
};

const isNoFeeUnlimited = computed(() => !isFinite(+props.token.noFeeLimit));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Caption, {
        caption: _unref(t)('singleSide.portfolio.caption'),
        tooltip: _ctx.$t('singleSide.portfolio.tooltip'),
        class: "mb-s1"
      }, null, 8, ["caption", "tooltip"]),
      _createElementVNode("div", null, _toDisplayString(__props.token.portfolio.name), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Caption, {
        caption: _unref(t)('singleSide.apr.caption'),
        tooltip: _ctx.$t('singleSide.apr.tooltip'),
        class: "mb-s1"
      }, null, 8, ["caption", "tooltip"]),
      _createElementVNode("div", null, _toDisplayString(printAPR()), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Caption, {
        caption: _unref(t)('singleSide.noFeeLimit.caption'),
        tooltip: _ctx.$t(`singleSide.noFeeLimit.tooltip.${__props.action}`),
        class: "mb-s1"
      }, null, 8, ["caption", "tooltip"]),
      (!_unref(isNoFeeUnlimited))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_unref(format)(__props.token.noFeeLimit.toFixed(2, _unref(BigNumber).ROUND_DOWN))), 1),
            _createVNode(TokenIcon, {
              "icon-src": __props.token.portfolioToken.tokenIconUrl,
              symbol: __props.token.portfolioToken.symbol,
              size: "16"
            }, null, 8, ["icon-src", "symbol"]),
            _createElementVNode("span", _hoisted_6, " / " + _toDisplayString(_unref(printUSD)(__props.token.noFeeLimitInUSD)), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('unlimited')), 1))
    ])
  ]))
}
}

})